import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { useField } from 'formik';
import { Error, Label } from 'src/shared-components/Form';

const errorClass =
  'focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300 focus:outline-none  ';
const normalClass = 'focus:ring-indigo-500 focus:border-indigo-500 border-gray-300';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{
    value: number | string;
    label: string;
  }>;
  label?: string;
  required?: boolean;
}

const Select: React.FC<SelectProps> = ({ options, label, required, ...rest }: SelectProps) => {
  const [field, { error, touched }] = useField({
    name: rest.name || '',
  });

  return (
    <div>
      {label && <Label text={label} name={rest.name || ''} required={required} />}
      <div className="mt-1 relative rounded-md">
        <select
          className={`block w-full pr-3 sm:text-sm border-0 rounded-md placeholder-gray-400 appearance-none bg-gray-100 text-sm ${
            field.value === '' ? 'text-gray-400' : 'text-gray-700'
          } font-medium py-3 px-4 leading-tight focus:outline-none focus:bg-gray-200 ${rest.className} ${
            error && touched ? errorClass : normalClass
          }`}
          {...field}
          {...rest}
        >
          <option value="" disabled>
            {rest.placeholder}
          </option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && touched && (
          <div className="absolute inset-y-0 right-5 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {error && touched && <Error error={error} />}
    </div>
  );
};

export default Select;
